import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export default function useQueryParams(): URLSearchParams {
  const { search } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  return searchParams;
}
